export default __webpack_public_path__ + "static/media/chat_hover.24df376d.svg";